// frontend/src/pages/Login.js
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore'; 
import { db } from '../firebase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setError('');
      
      // 1. Perform the Firebase Auth Login
      const userCred = await login(email, password);
      const user = userCred.user;

      // 2. Check Firestore for the user's role
      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);

      // 3. Redirect based on role
      if (userDoc.exists() && userDoc.data().role === 'chatter') {
          navigate('/chatter');
      } else {
          // Default to admin for safety, or if role is missing/admin
          navigate('/admin');
      }

    } catch (err) {
      setError('Failed to log in: ' + err.message);
    }
  }

  return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#1e1e1e', color: 'white' }}>
      <form onSubmit={handleSubmit} style={{ padding: '40px', background: '#252526', borderRadius: '8px', border: '1px solid #333' }}>
        <h2>SHIELD Portal</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ width: '100%', padding: '8px' }} />
        </div>
        <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required style={{ width: '100%', padding: '8px' }} />
        </div>
        <button type="submit" style={{ width: '100%', padding: '10px', background: '#007acc', color: 'white', border: 'none', cursor: 'pointer' }}>Log In</button>
      </form>
    </div>
  );
}